import { getLanguageCode } from 'chat-ui/src/utils/getLanguageCode';
import { getRespondentUiTranslation } from 'chat-ui/src/translations/respondentUiTranslations';

interface Props {
  onReload: () => void;
}

/**
 * Branded full-page recovery screen shown when the app crashes. Shared by
 * the class ErrorBoundary (errors outside the router) and
 * RouteErrorFallback (route render errors, which React Router catches
 * before the class boundary can see them). Language is resolved at render
 * time from localStorage/navigator because the crashed tree provides no
 * project context.
 */
function ErrorFallbackScreen({ onReload }: Props) {
  const t = getRespondentUiTranslation(getLanguageCode());
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center bg-white">
      <div className="flex flex-col items-center gap-4 max-w-sm">
        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-red-50">
          <svg
            className="w-7 h-7 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-gray-900">{t.errorBoundaryTitle}</h2>
        <p className="text-sm text-gray-500">{t.errorBoundaryMessage}</p>
        <button
          type="button"
          onClick={onReload}
          className="px-5 py-2.5 text-sm font-medium text-white bg-[#FF6F98] rounded-lg hover:bg-[#e5607f] transition-colors"
        >
          {t.errorBoundaryReloadButton}
        </button>
      </div>
    </div>
  );
}

export default ErrorFallbackScreen;
